import { Controller } from "@hotwired/stimulus"
import { createAlert } from '../scripts/createAlert';

export default class extends Controller {
  static targets = [ "input", "quill", "form" ]

  connect() {
    // console.log("Hello, Stories Interview Template Settings Controller here!", this.element)
    // console.log(this.emailTemplateTarget)
  }


  attemptSubmit(event) {
    // when submitting, need to make sure the email template has {{Link}} or {{Button}} tags
    event.preventDefault();

    var valid = true

    // this was stolen from the Quill controller, because it runs on Submit there
    // but we're needing to check it BEFORE submit here
    var tempElement = document.createElement('body');
    tempElement.innerHTML = this.inputTarget.value;
    [...tempElement.querySelectorAll('p')].forEach(para => {
      if (para.innerText.trim() === "") tempElement.removeChild(para);
    });
    var text = tempElement.innerHTML

    if (!text || text === "" || text === "<p></p>") {
      // Quill editor is empty, so no need to validate
      this.inputTarget.value = "";
      this.formTarget.submit();
      return;
    }

    if (!text.includes("{{Link}}") && !text.includes("{{Button}}")) {
      this.quillTarget.style.setProperty('border', '1px solid red', 'important');
      valid = false
    } else {
      this.quillTarget.style.setProperty('border', '1px solid #ccc');
    }

    if (valid) {
      this.formTarget.submit();
    } else {
      createAlert('danger', 'Email template must contain Button or Link tags');
    }
  }

}
